import { t as CourseLessonsSkeleton } from "./course-lessons-skeleton-JRPwpay0.js";
import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/use-course-lessons.tsx
var LazyCourseLessons = lazy(() => import("./course-lessons-CgZE-yp5.js").then((n) => n.n).then((module) => ({ default: module.CourseLessons })));
function CourseLessons({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(CourseLessonsSkeleton, {}),
		children: /* @__PURE__ */ jsx(LazyCourseLessons, { ...props })
	});
}
function CourseLessonsContent({ ...props }) {
	return /* @__PURE__ */ jsx(LazyCourseLessons, { ...props });
}
var useCourseLessonsContent = () => {
	return useMemo(() => ({ courseLessons: {
		component: CourseLessonsContent,
		loadingComponent: /* @__PURE__ */ jsx(CourseLessonsSkeleton, {})
	} }), []);
};
//#endregion
export { CourseLessons, useCourseLessonsContent };
